<div class="w100">
    <img 
        [src]="url" 
    />
</div>